import type { StateStorage } from 'zustand/middleware';

export const synchronousLocalStorage: StateStorage = {
  getItem: (name) => {
    if (typeof window === 'undefined') {
      return null;
    }

    try {
      return window.localStorage.getItem(name);
    } catch {
      return null;
    }
  },

  setItem: (name, value) => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      window.localStorage.setItem(name, value);
    } catch {
      // Ignore storage failures so resume-critical writes do not crash the app.
    }
  },

  removeItem: (name) => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      window.localStorage.removeItem(name);
    } catch {
      // Ignore storage failures so cleanup remains best-effort.
    }
  },
};

export function getSynchronousLocalStorage(): StateStorage {
  return synchronousLocalStorage;
}
